// src/pages/ServicePricing.js
import React, { useEffect, useState } from "react";
import { get, onValue, ref, set, update } from "firebase/database";
import { auth, db } from "../../utilities/firebaseConfig";
import { Link, useNavigate } from "react-router-dom";
import backicon from "../../assets/backicon.svg";
import editingicon from "../../assets/editicon.svg";

const ServicePricing = () => {
  const [pricing, setPricing] = useState({ service: "", price: "" });
  const navigate = useNavigate();
  const [categories, setCategories] = useState({});
  // const [selectedCategory, setSelectedCategory] = useState(
  //   "Appliance Installation and Repairs"
  // );
  const [services, setServices] = useState([]);
  const [showcat, setShowcat] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [technician, setTechnician] = useState(null);
  const [online, setOnline] = useState(false);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      navigate("/");
      return;
    }

    const technicianId = auth.currentUser ? auth.currentUser.uid : null;
    if (!technicianId) return;

    // Fetch technician details
    const technicianRef = ref(db, `technicians/${user.uid}`);
    onValue(technicianRef, (snapshot) => {
      if (snapshot.exists()) {
        const techData = snapshot.val();
        setTechnician(techData);
        setOnline(techData.online);
      }
    });
  }, [navigate]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const snapshot = await get(ref(db, "categories"));
        if (snapshot.exists()) {
          const data = snapshot.val();
          let servicesList = [];
          Object.values(data).forEach((category) => {
            if (category.services) {
              Object.values(category.services).forEach((service) => {
                servicesList.push(service.name);
              });
            }
          });
          setServices(servicesList);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchServices();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const snapshot = await get(ref(db, "categories"));
        if (snapshot.exists()) {
          setCategories(snapshot.val());
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  const handleCategoryChange = (categoryName) => {
    setSelectedCategory(categoryName);
    setSelectedServices([]); // Reset selected services when changing category
  };

  // Handle selecting and removing services
  const handleServiceToggle = (serviceName) => {
    setSelectedServices((prevServices) => {
      const existingService = prevServices.find((s) => s.name === serviceName);

      if (existingService) {
        // Remove service if already selected
        return prevServices.filter((s) => s.name !== serviceName);
      } else {
        // Add service with a default price of 0
        return [...prevServices, { name: serviceName, price: 0 }];
      }
    });
  };

  // Update local state when price is changed
  const handleServicePriceChange = (index, newPrice) => {
    if (!technician || !technician.services) return;

    const updatedServices = technician.services.map((service, i) =>
      i === index ? { ...service, price: newPrice } : service
    );

    setTechnician({ ...technician, services: updatedServices });
  };

  // Save new price to Firebase
  const handleSavePrice = async (index) => {
    const user = auth.currentUser;
    if (!user || !technician) return;

    const updatedService = technician.services[index];
    const technicianRef = ref(db, `technicians/${user.uid}/services/${index}`);

    await update(technicianRef, { price: updatedService.price });

    alert(`Price for ${updatedService.name} updated successfully!`);
  };

  const formatPrice = (price) => {
    if (!price) return "";
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <>
      <div className={`navbar visible`}>
        <div className='navbar-container'>
          <div className='navbar-logo-left'>
            <Link to='/dashboard' className='navbar-logo'>
              ProfixExpress
            </Link>
          </div>
        </div>
      </div>
      <div className='bookingpagecnt'>
        <button
          className='backicon'
          onClick={() => navigate("/technician/dashboard")}
        >
          <img src={backicon} className='backiconimg' alt='' srcset='' />
        </button>

        <div className='thebiggap'></div>
        <div className='theprofnap'>
          <p>Services</p>
          <button onClick={() => setShowcat(true)}>
            <img src={editingicon} alt='' /> Add services
          </button>
        </div>
        <div className='thebxcnt'>
          <div className='thebio'>
            <p className='thebiotitle'>Specializations</p>
            {technician?.services && technician?.services.length > 0 ? (
              <div className='thebioserv'>
                {technician?.services.map((service, index) => (
                  <p className='thebioservword' key={index}>
                    {service.name} <span> ₦ {formatPrice(service.price)}</span>
                  </p>
                ))}
              </div>
            ) : (
              <p>No services listed.</p>
            )}
          </div>
        </div>
        <div className='thebiggap'></div>

        <div className='thebxcnt'>
          <div className='thebio'>
            <p className='thebiotitle'>Service Pricing.</p>
            {technician?.services && technician?.services.length > 0 ? (
              <div className='thesase'>
                {technician.services.map((service, index) => (
                  <div key={index} className='service-edit'>
                    <p className='scse'>{service.name} </p>
                    <div className='theservinput'>
                      <input
                        type='number'
                        value={service.price}
                        onChange={(e) =>
                          handleServicePriceChange(index, e.target.value)
                        }
                      />
                      <button onClick={() => handleSavePrice(index)}>
                        Save
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>No services listed.</p>
            )}
          </div>
        </div>
      </div>

      {showcat && (
        <>
          <div className='downmodal' onClick={() => setShowcat(false)}></div>{" "}
          <div className='downmodalbody'>
            <div className='downmodalway'>
              <div className='thegap'></div>
              <div className='inputcnt'>
                <label>What Category does your task fall under?</label>
                <div className='category-buttons'>
                  {Object.keys(categories).map((categoryName) => (
                    <button
                      key={categoryName}
                      onClick={() => handleCategoryChange(categoryName)}
                      className={`category-btn ${
                        selectedCategory === categoryName ? "active" : ""
                      }`}
                    >
                      {categoryName}
                    </button>
                  ))}
                </div>
              </div>

              <div className='divider'></div>

              <div className='thegap'></div>

              {/* Service Selection */}
              {selectedCategory && categories[selectedCategory]?.services && (
                <div>
                  <label className='thealtinput'>
                    What is the service type?
                  </label>
                  <div className='thespace'></div>
                  <div className='service-options'>
                    {Object.values(categories[selectedCategory].services).map(
                      (service) => (
                        <div key={service.name} className='service-item'>
                          <input
                            type='checkbox'
                            id={service.name}
                            checked={selectedServices.some(
                              (s) => s.name === service.name
                            )}
                            onChange={() => handleServiceToggle(service.name)}
                          />
                          <label
                            className='category-btn'
                            htmlFor={service.name}
                          >
                            {service.name}
                          </label>
                        </div>
                      )
                    )}
                  </div>
                </div>
              )}
              <div className='thegap'></div>
              {/* Display Selected Services */}
              <div className='selected-services'>
                {selectedServices.length > 0 ? (
                  <div className='selected-services-list'>
                    {selectedServices.map((service, index) => (
                      <div key={index} className='selected-service'>
                        <span>{service.name}</span>
                        <button
                          onClick={() => handleServiceToggle(service.name)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p></p>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ServicePricing;
